import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import { MyStore, reducers } from 'kts-platform-frame/redux';
import { create } from 'kts-scaffold-framework/utils/form';
import { Button, Form, Upload, message, Modal } from 'antd';   
import { serverDomain } from 'kts-platform-frame/entry/configUtils';  
import { Urls } from 'kts-platform-frame/entry/constant';
const css = require('./index.scss');
const FormItem = Form.Item;
const formItemLayout = {
    labelCol: { span: 0 },
    wrapperCol: { span: 24 },
}; 

/** Redux接口 */
interface IReduxStatePart {
    
}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {

}

/** 绑定全局数据到props */
@create()
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({

}))
export default class UIComponents extends UIBasic<IProps, ModulesState> {

    constructor(props: IProps) {
        super(props, ModulesAction);
        this.state = {
            fileList: [], 
            CanSecUpload: false, 
        };
    }   
    beforeUpload = (file) => {  
        const isExcel = (file.name.toLowerCase().split('.').splice(-1)[0] === 'xls' || file.name.toLowerCase().split('.').splice(-1)[0] === 'xlsx');
        if (!isExcel) {
            message.error('只能上传.xls或.xlsx格式的文档!'); 
            file.status = 'error'; 
            return false;
        }
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
            message.error('上传文件限制2MB!'); 
            file.status = 'error'; 
            return false;
        } 
        this.props.form.setFieldsValue({
            dragger: [file]
        });
        return isExcel && isLt2M;
    }
    normFile = (e) => { 
        e.fileList = e.fileList.slice(0, 1);
        if (Array.isArray(e)) {
          return e;
        } 
        return e && e.fileList;
    }
    removeFile = (file) => { 
        console.log('remove file');
    }
    changeFile = (info) => {
        if (info.file.status !== 'uploading') {
            console.log(info.file, info.fileList);
            this.setState({CanSecUpload: false});
        }
        if (info.file.status === 'done') {
            // 文件上传成功
            let result = info.file.response; 
            if (!result.ok) { 
                message.error(`${result.status.description}`); 
            } else {
                console.log('0000kkkkk');
                if (!result.body.result) { 
                    let failedResult = result.body.failedInfo || [];
                    Modal.error({
                        title: '批量创建预检查反馈',
                        content: failedResult.map((item, index)=>{
                            return <p key={index}>名称: {item.name}, 账号: {item.email}, {item.errorMsg} 。</p>;
                        }),
                    });
                    return false;
                }
                // 预检查通过，第二次提交页面
                this.setState({CanSecUpload: true});
            }
            // message.success(`${info.file.name} file uploaded successfully`);
          } else if (info.file.status === 'error') { 
            // message.error(`${info.file.name} 文件上传失败.`);
        }
    }
    render() {
        const { getFieldDecorator } = this.props.form; 
        const { user } = MyStore.instance.getState();  
        const { fileList } = this.state;
        const domain = 'http://' + location.host;
        const props = {
            action: serverDomain() + Urls.userBatchPreTreated + '?domain=' + domain,
            headers: {
                Authorization: user.cToken ,
                zoneUrl: serverDomain()
            }, 
            onRemove: this.removeFile, 
            onChange: this.changeFile,
            
        }; 

        const Dragger = Upload.Dragger as any;

        return (
            <div className={`uploadbatchtext asideroverall`}>
                <Form onSubmit={this.handleSubmit}> 
                    <FormItem style={{paddingLeft: '10px', marginBottom: '0px'}}>
                    <a href="/template/batch_create_user.xlsx" download="用户列表模板.xlsx" className="ml-5 uploadueracolor">下载用户列表模板</a>
                    </FormItem>
                    <FormItem
                        style={{ paddingTop: '0px'}}
                        {...formItemLayout} 
                    >
                        <div className="dropbox">
                            {getFieldDecorator('dragger', {
                            valuePropName: 'fileList',
                            getValueFromEvent: this.normFile,
                            })(
                            <Dragger {...props} fileList={fileList} beforeUpload={this.beforeUpload} multiple={false} >
                              <p className="ant-upload-drag-icon">
                                <i className="anticon anticon-shangchuan"></i>
                                </p>
                                <p className="ant-upload-text">点击或拖拽文件至此上传</p> 
                                <p className="ant-upload-hint">仅支持xls或xlsx文件格式</p>
                            </Dragger>
                            )}
                        </div> 
                    </FormItem>
                </Form> 
                <div style={{textAlign: 'center'}} className={css.uploadbatchcancel}>
                    <Button className={css.canceluploadbatch} type="primary" disabled={!this.state.CanSecUpload} onClick={this.handleSubmit}>批量邀请</Button>
                    <Button className={`${css.canceluploadbatch} defaultbtn height46`} onClick={ModulesAction.hideAside} type="default" >关闭</Button> 
                </div>
          </div>
        );
    } 
    /** 提交表单 */
    private handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => { 
          if (!err) { 
              ModulesAction.sendUpload(values.dragger[0].originFileObj); 
            // this.setState({CanSecUpload: false});
          }
        });
    }
}



// WEBPACK FOOTER //
// ./src/display/platform/UserManage/UI.Create.User.Batch.tsx